<img class="client-logo" src="client_logo.png" alt="@company_logo">
<h1>Server connection not available</h1>
<h2>An error occurred during the communication with the backend, try again later</h2>

<div class="actions">
    <button mat-raised-button (click)="refresh()">
        <mat-icon>refresh</mat-icon>
        Refresh
    </button>
    <button mat-raised-button (click)="logout()">
        <mat-icon>logout</mat-icon>
        Log Out
    </button>
</div>
<img class="ubi-logo" src="app_logo_black.svg" alt="UBI Solutions">
